import React from "react";

const SvgTreatment = props => (
  <svg data-name="Layer 1" viewBox="0 0 215 215" {...props}>
    <path
      fill="currentColor"
      d="M115.6 103.19H99.4v16.19H83.21v16.2H99.4v16.2h16.2v-16.2h16.19v-16.2H115.6v-16.19z"
    />
    <path
      d="M107.55 31.68l-59.14 74.17h25.06v77.47h68.06v-77.47h25.06zm31 71.17v77.47H76.47v-77.47H54.64l52.91-66.36 52.82 66.36z"
      fill="currentColor"
    />
  </svg>
);

export default SvgTreatment;